module.exports = __webpack_public_path__ + "static/img/mz1.67fb6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mz1.png
// module id = vhrt
// module chunks = 99